import { CurrentState } from "../../currentState"

export function getNewPetDetails() {
    return {
        RelocationPlanPetID: 0,
        RelocationPlanID: 0,
        GenderTypeID: '',
        PetTypeID: '',
        Desexed: '',
        Breed: '',
        SizeID: '',
        Age: 0,
        Name: '',
        ConcurrencyCheck: 0,
        GenderTypeDescription: null,
        PetTypeDescription: null,
        SizeDescription: null,
        IsVaccinationsUpToDate: false,
        Height: 0,
        Weight: 0,
        CurrentState: 0,
        modified: false,
    }
}

export function getPetDetails(petInfo) {
    petInfo.CurrentState = CurrentState.Unchanged;
    return petInfo;
}